import { TabPanel, TabView } from "primereact/tabview";
import React, { useState } from "react";
import { setButtonsText } from "../../../store/banner/bannerSlice";
import { NewsAnalyticsInfo } from "./analytics/newsAnalytics";
import { LatestNews } from "./newsFeedListing/latestNews";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataListTemplates } from "../../../common/constants";

export const NewsFeed = () => {
  const dispatch = useDispatch();
  const [sourceName, setSourceName] = useState("");
  const [totalNews, setTotalNews_fn] = useState();
  const bannerContent = {
    tabName: "News Feed",
    actionsJSX: (
      <>
        <div className="cancel-save-btns"></div>
      </>
    ),
  };
  useEffect(() => {
    dispatch(setButtonsText(bannerContent));
    return () => {
      dispatch(setButtonsText(""));
    };
  }, []);

  const chartConfig = useSelector((x) => x.chart.chartConfig);

  if (chartConfig && chartConfig.widgets) {
    var chartConfigObject = chartConfig.widgets.find(
      (x) => x.moduleName === DataListTemplates.news
    );
  }

  const onAnalyticsDataFetch = (analyticsData) => {
    if (analyticsData && analyticsData.totalDatasets) {
      setTotalNews_fn(analyticsData.totalDatasets);
    }
  };

  return (
    <>
      <div className="upload_documents">
        <div className="slb-container-fluid">
          <div className="pt-1">
            {chartConfigObject ? (
              <NewsAnalyticsInfo
                onDataFetch={onAnalyticsDataFetch}
                dataListTemplate={DataListTemplates.news}
                setSourceName={setSourceName}
                chartConfig={chartConfigObject}
              />
            ) : (
              <></>
            )}
            {/* <NewsAnalyticsInfo  onDataFetch={onAnalyticsDataFetch} setSourceName={setSourceName}/> */}
          </div>

          <LatestNews sourceName={sourceName} />
        </div>
      </div>
    </>
  );
};
